import { render } from "./RenameCatalogDialog.vue?vue&type=template&id=7abd8626"
import script from "./RenameCatalogDialog.vue?vue&type=script&lang=js"
export * from "./RenameCatalogDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__